import { onAuthStateChanged } from 'firebase/auth';
import React, { useEffect, useState } from 'react'
import { useDataProvider, required, SimpleForm, minValue, TextInput, useNotify, SelectInput } from 'react-admin';
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../../firebase';
import { CardHeader, CardContent, Grid, CardActions, Button } from '@material-ui/core';
import _extendLayout from '../../layout/_extendLayout';
import { doc, updateDoc } from 'firebase/firestore';

const Topup = () => {
    const [employeeChoices, setEmployeeChoices] = useState([]);
    const [clientId, setClientId] = useState("");
    const navigate = useNavigate();
    const notify = useNotify();
    const dataProvider = useDataProvider();

    useEffect(() => {
        const checkAuth = onAuthStateChanged(auth, (user) => {
            if (user) {
                fetchCurrentUser(user.uid);
            }
        });

        return () => checkAuth();
    }, []);

    const fetchCurrentUser = async (userId) => {
        try {
            const res = await dataProvider.getOne("users", { id: userId });
            setClientId(res.data?.client?.id);
            fetchEmployeeList(res.data?.client?.id);
        } catch (err) {
            console.log("error: ", err);
        }
    }

    const fetchEmployeeList = async (clientId) => {
        try {
            const { data: employees } = await dataProvider.getList("employees", {
                filter: { "client": clientId },
                pagination: { page: 1, perPage: 1000 },
            });
            const formattedEmployeeList = employees.map((employee) => {
                const id = employee.id;
                const name = employee.fullName || "Unknown Name";
                const cardNumber = employee.cardNumber || "No Card Number";
                const credit = employee.credit || 0;
                return { id, name: `${name}-[${cardNumber}]`, credit };
            });
            setEmployeeChoices(formattedEmployeeList);
        } catch (error) {
            console.log("error: ", error);
        }
    }

    const handleSave = async (data) => {
        const { employees: employee, credit } = data;
        if(!employee || credit == null) {
            return;
        }

        const selectedEmployee = employeeChoices.find((emp) => emp.id === employee);
        const existingCredit = selectedEmployee?.credit ?? 0;
        const newCredit = Number((Number(existingCredit) + Number(credit)));
        try {
            const employeeRef = doc(db, "employees", employee);
            await updateDoc(employeeRef, {
                credit: newCredit
            });
            notify("Credit updated successfully", { type: "success" });
            navigate("/employees");
        } catch (error) {
            console.log("error: ", error);
        }
    };

    return (
        <>
            <_extendLayout>
                <div style={{ width: '95%' }}>
                    <CardHeader title="Topup" />
                    <CardContent>
                        <p>Search by employee to top-up their credit.</p>
                        <SimpleForm toolbar={null} onSubmit={handleSave}>
                            <Grid container spacing={3}>
                                <Grid item mb={2} xs={12} sm={12} md={6}>
                                    <SelectInput
                                        fullWidth
                                        label="Employee No"
                                        source='employees'
                                        choices={employeeChoices}
                                        sx={{ marginTop: 0, marginBottom: 0 }}
                                    />
                                </Grid>
                                <Grid item mb={2} xs={12} sm={12} md={6}>
                                    <TextInput
                                        label="Credit"
                                        source="credit"
                                        type="number"
                                        fullWidth
                                        validate={[required('Please enter a credit.'), minValue(0, 'Credit cannot be lower than 0.')]}
                                        variant="outlined"
                                    />
                                </Grid>
                                <CardActions>
                                    <Button type="submit" variant="contained" color="primary">
                                        Top-up
                                    </Button>
                                </CardActions>
                            </Grid>
                        </SimpleForm>
                    </CardContent>
                </div>
            </_extendLayout>
        </>
    )
};

export default Topup;
